import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const CalendarIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M7.55556 6.44444V2M16.4444 6.44444V2M6.44444 10.8889H17.5556M4.22222 22H19.7778C20.3671 22 20.9324 21.7659 21.3491 21.3491C21.7659 20.9324 22 20.3671 22 19.7778V6.44444C22 5.85507 21.7659 5.28984 21.3491 4.8731C20.9324 4.45635 20.3671 4.22222 19.7778 4.22222H4.22222C3.63285 4.22222 3.06762 4.45635 2.65087 4.8731C2.23413 5.28984 2 5.85507 2 6.44444V19.7778C2 20.3671 2.23413 20.9324 2.65087 21.3491C3.06762 21.7659 3.63285 22 4.22222 22Z"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  ),
);

CalendarIcon.displayName = 'CalendarIcon';
